import React from 'react';
import { MessageDescriptor } from 'react-intl';

export type IntlMessage = MessageDescriptor & { values?: Record<string, any> };

export enum NotificationType {
  INFO = 'INFO',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

export enum ComponentType {
  ALERT = 'ALERT',
  MODAL = 'MODAL',
}

export interface Collapse {
  title: IntlMessage | React.ReactNode;
  description: IntlMessage | React.ReactNode;
}

export default interface Notification {
  id?: number;
  title: IntlMessage;
  description?: IntlMessage;
  collapse?: Collapse;
  type: NotificationType;
  duration?: number;
  componentType?: ComponentType
}

export const isIntlMessage = (message: any): message is IntlMessage => (
  Boolean(message?.id && message?.defaultMessage)
);
